import { render } from "./protocol_winners2.vue?vue&type=template&id=4bcc5384"
import script from "./protocol_winners2.vue?vue&type=script&lang=js"
export * from "./protocol_winners2.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vue/js/components/sale/protocol/create/tabs/protocol_winners2.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4bcc5384"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4bcc5384', __exports__)) {
    console.log('reload')
    api.reload('4bcc5384', __exports__)
  }
  
  module.hot.accept("./protocol_winners2.vue?vue&type=template&id=4bcc5384", () => {
    console.log('re-render')
    api.rerender('4bcc5384', render)
  })

}


export default __exports__